import { createSelector } from "@reduxjs/toolkit";

export const filtersSelector = (state) => state.filters;

export const hasFiltersEnabledSelector = createSelector(
  filtersSelector,
  (filters) => !!Object.keys(filters).length
);

export const appliedFiltersCountSelector = createSelector(
  filtersSelector,
  (filters) => Object.keys(filters).length
);

export const filterValueSelector = (field) =>
  createSelector(filtersSelector, (filters) => filters[field]);
